import { Stack, Typography } from "@mui/material";
import { ReactNode } from "react";

/** A drawer header fact: a caption label over its value, hidden when there is no value. */
export function LabeledValue({ label, value }: { label: string; value: ReactNode }) {
  if (value === null || value === undefined || value === "") return null;
  return (
    <Stack spacing={0.5}>
      <Typography variant="caption" color="text.secondary">
        {label}
      </Typography>
      <Typography variant="body2" component="div">
        {value}
      </Typography>
    </Stack>
  );
}
